import {
  HEYDEX_DEFAULT_MODEL_SELECTION,
  type ModelCapabilities,
  type ProviderDriverKind,
  type ProviderInstanceId,
  type ServerProvider,
  type ServerProviderModel,
} from "@heydex/contracts";
import { resolveSelectableModel } from "@heydex/shared/model";

const EMPTY_CAPABILITIES: ModelCapabilities = { optionDescriptors: [] };

/** The driver of the requested instance when it is enabled, else of any enabled instance. */
export function resolveSelectableProvider(
  providers: ReadonlyArray<ServerProvider>,
  provider: ProviderDriverKind | ProviderInstanceId | null | undefined,
): ProviderDriverKind | undefined {
  const requested = providers.find((candidate) => candidate.instanceId === provider);
  return requested?.enabled
    ? requested.driver
    : providers.find((candidate) => candidate.enabled)?.driver;
}

export function getProviderModelCapabilities(
  models: ReadonlyArray<ServerProviderModel>,
  model: string | null | undefined,
): ModelCapabilities {
  const slug = resolveSelectableModel(model, models);
  return models.find((candidate) => candidate.slug === slug)?.capabilities ?? EMPTY_CAPABILITIES;
}

export function getDefaultServerModel(
  providers: ReadonlyArray<ServerProvider>,
  provider: ProviderDriverKind | undefined,
): string {
  return (
    providers.find((candidate) => candidate.driver === provider)?.models[0]?.slug ??
    HEYDEX_DEFAULT_MODEL_SELECTION.model
  );
}
